/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add-process': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M672 384V211.2L288 512l384 300.8V640h352V384H672zm288 192H608v105.6L393.6 512 608 342.4V448h352v128z"/><path pid="1" d="M384 896H64V128h320v227.2l64-51.2V64H0v896h448V720l-64-51.2z"/>'
  }
})
